import { render, staticRenderFns } from "./SubmitForm11.vue?vue&type=template&id=8f982842&scoped=true"
import script from "./SubmitForm11.vue?vue&type=script&lang=ts"
export * from "./SubmitForm11.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f982842",
  null
  
)

export default component.exports